<template>
  <section class="tabs-container my-5">
    <b-row>
      <b-col lg="4" v-if="availableSlots.length > 0">
        <ButtonGroup class="tabs-controls" v-model="selectedTab" :buttons="buttons"
        @change="track('selectedTab', 'Selecionou uma das abas')"></ButtonGroup>
      </b-col>
      <b-col class="tabs tabs-content">
        <slot name="selectedTab"/>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import ButtonGroup from '@/components/form/ButtonGroup';

export default {
  name: 'Tabs',
  components: {
    ButtonGroup,
  },
  data() {
    return {
      selectedTab: null,
    };
  },
  computed: {
    buttons() {
      return this.availableSlots.map(($slot, index) => {
        const { label = `Tab ${index}`, shortLabel = null, buttonClass = '' } = $slot.data.attrs;
        return {
          name: label,
          shortName: shortLabel,
          value: $slot,
          class: `${buttonClass} d-lg-flex justify-content-center align-items-center tabs-controls__button medium-rounded`,
        };
      });
    },
    availableSlots() {
      return this.$slots.default ? this.$slots.default.filter(s => s.data) : [];
    },
  },
  methods: {
    setSelectedTab($slot) {
      this.selectedTab = $slot;
    },
  },
  watch: {
    selectedTab: {
      immediate: true,
      handler() {
        if (this.selectedTab) {
          this.$slots.selectedTab = [this.selectedTab];
          const trackLabel = this.selectedTab.data.attrs.trackWithLabel;
          if (trackLabel) {
            this.track(trackLabel);
          }
        }
      },
    },
  },
  mounted() {
    if (this.availableSlots.length > 0) {
      this.setSelectedTab(this.availableSlots[0]);
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .tabs-controls__button {
    margin-bottom: 10px;
    font-size: 14px;
    color: $text-warning;
    text-align: left;
    text-indent: 0;
  }
  .button-group-item-name {
    margin-left: 5px;
  }
  @media screen and (min-width: $lg){
    .tabs-controls .btn-group {
      flex-wrap: wrap;
    }

    .tabs-controls__button {
      margin-left: 0!important;
      width: 100%;
      flex-shrink: 0;
      padding: 35px;
      &:last-child {
        margin-bottom: 0!important;
      }
      .button-group-item-name {
        max-width: 120px;
      }
    }
  }
}
</style>
